export default "__VITE_ASSET__BxT4sQsg__"